import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">How to enter?</div>
        <p>
          Eligible entrants can enter The T-Shirt Giveaway by submitting an
          entry via the online form provided at www.bunk4study.com As a
          participant, your entry must fully meet allGiveaway requirements, as
          specified in the Official Rules, in order to be eligible to win a
          prize. Incomplete entries or those that do not adhere to the Official
          Rules or specifications will be disqualified at the Sponsor's sole
          discretion. Fraudulent methods of entry or circumvention of the rules
          may result in the Sponsor invalidating your entries and removing them
          from the Giveaway at theSponsor’s sole discretion Giveaway
          substantially as described in these Official Rules.
        </p>
      </div>
    </div>
  );
};

export default Q2;
